import { useEffect } from 'react';

/* 
  Hook used to remove the browser auto scroll at page level.
  Use it on pages with infinite scroll such as /cruises 
  after loading more cruises. 
*/

const useAutoScrollRemoval = () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  useEffect(
    () => () => {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
    },
    [],
  );
};

export default useAutoScrollRemoval;
